(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('CategoryDetailController', CategoryDetailController);

    CategoryDetailController.$inject = ['$scope', '$q', '$rootScope', '$stateParams', 'entity', 'Category','$uibModalInstance', 'Qinius'];

    function CategoryDetailController($scope, $q, $rootScope, $stateParams, entity, Category, $uibModalInstance, Qinius) {
        var vm = this;

        vm.category = entity.data;
        vm.clear = clear;
        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        })
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        var unsubscribe = $rootScope.$on('backApp:categoryUpdate', function(event, result) {
            vm.category = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
